import { Divider, FigmaTypography } from "@libs/zapi-ui/custom";
import React from "react";

type TCostsProps = {
  source: string;
  inputTokens: number;
  cachedInputTokens: number;
  outputTokens: number;
  cost?: number;
  sourceCost?: string;
  cacheHit: boolean | null;
};

export function Costs({ cost, source, outputTokens, inputTokens, cachedInputTokens, sourceCost, cacheHit }: TCostsProps) {
  if (cacheHit) {
    return (
      <div>
        <FigmaTypography variant="body-3" className="text-zinc-1000">
          Cache hit
        </FigmaTypography>
      </div>
    );
  }
  return (
    <div>
      <FigmaTypography variant="body-3" className="text-zinc-1000">
        Source: {source}
      </FigmaTypography>
      <div>
        <FigmaTypography variant={"body-2"} className="text-zinc-1000 mt-1.5">
          Request
        </FigmaTypography>
        <FigmaTypography variant="body-3" className="text-zinc-1000">
          Tokens: {inputTokens}
        </FigmaTypography>
        {cachedInputTokens > 0 && (
          <FigmaTypography variant="body-3" className="text-zinc-1000">
            Cached tokens: {cachedInputTokens}
          </FigmaTypography>
        )}
      </div>
      <Divider className={"my-2"} />
      <div>
        <FigmaTypography variant="body-2" className="text-zinc-1000 mt-1.5">
          Response
        </FigmaTypography>
        <FigmaTypography variant="body-3" className="text-zinc-1000">
          Tokens: {outputTokens}
        </FigmaTypography>
      </div>
      <Divider className={"my-2"} />
      <div>
        <FigmaTypography variant="body-2" className="text-zinc-1000 mt-1.5">
          Cost
        </FigmaTypography>
        <FigmaTypography variant="body-3" className="text-zinc-1000">
          Source: {sourceCost}
        </FigmaTypography>
        <FigmaTypography variant="body-3" className="text-zinc-1000 mt-1.5">
          Total Cost: {cost ? `$${cost.toFixed(6)}` : "N/A"}
        </FigmaTypography>
      </div>
    </div>
  );
}
